import { useEffect, useState } from 'react'
import { Image } from 'react-native'

/**
 * Teste su misura dei corridori, scaricate da Supabase Storage (bucket pubblico 'avatar-heads') invece di stare nell'app:
 * non pesano sull'OTA (limite 1000 asset) ne' sull'app installata.
 *
 * dim_rider.avatar.head = { slug, v }: il foglio e' avatar-heads/<slug>/<full|tiny>.png?v=<v> (v cambia quando la testa viene rifatta,
 * cosi' la cache del telefono si aggiorna). Il foglio ha le caselle in posizione fissa (HEAD_TILES, 4 colonne x 3 righe), con lo stesso
 * formato dei fogli interni (scripts/build_custom_heads.py): full = caselle 512 px con bordo 4, tiny = 192 px con bordo 2.
 * Finche' il foglio non e' scaricato l'avatar mostra la testa normale del corridore (nessun buco); dopo resta in cache.
 */
export const HEAD_TILES = ['skin', 'white', 'iris', 'lips', 'brow', 'ink', 'mouth', 'beard', 'beardline', 'hair', 'hairline']
const COLS = 4, ROWS = 3
const TIERS = { full: { s: 512, g: 4 }, tiny: { s: 192, g: 2 } }

let base = `${process.env.EXPO_PUBLIC_SUPABASE_URL}/storage/v1/object/public/avatar-heads`
/** Solo per le prove in locale: un altro indirizzo da cui prendere i fogli. */
export function setHeadsBase(url) { base = url }

const ready = new Set()        // fogli gia' scaricati (in questa sessione: poi ci pensa la cache delle immagini)

export function headUri(head, tier) {
  return head?.slug ? `${base}/${head.slug}/${tier}.png?v=${head.v ?? 1}` : null
}

/** Foglio della testa su misura pronto da disegnare (stesso formato dei fogli di personAvatarAtlas), o null se manca o sta scaricando. */
export function useRemoteHead(head, tier) {
  const uri = headUri(head, tier)
  const [, setTick] = useState(0)
  useEffect(() => {
    if (!uri || ready.has(uri)) return undefined
    let alive = true
    Image.prefetch(uri)
      .then((ok) => { if (ok !== false) { ready.add(uri); if (alive) setTick((t) => t + 1) } })
      .catch(() => {})          // rete assente o foglio mancante: resta la testa normale
    return () => { alive = false }
  }, [uri])
  if (!uri || !ready.has(uri)) return null
  return { src: { uri }, ...TIERS[tier], cols: COLS, rows: ROWS }
}

/** Casella di un livello della testa su misura nel foglio: [colonna, riga] o null. brow1/brow2 e beardN usano brow e beard. */
export function headTile(key) {
  const i = HEAD_TILES.indexOf(key.replace(/^(brow|beard)\d+$/, '$1'))
  return i < 0 ? null : [i % COLS, Math.floor(i / COLS)]
}
